import {
  ScoreSt,
  ScorePlainSt,
  ScoreTextSt,
  ScoreValueSt,
  ScoreMaxSt,
} from './Score.css';
import { Donut } from '../Donut/Donut';

const Score = ({ value, max }) => {
  return (
    <ScoreSt>
      <ScorePlainSt />
      <ScoreTextSt>
        <ScoreValueSt>{value}</ScoreValueSt>
        <ScoreMaxSt>/ {max}</ScoreMaxSt>
      </ScoreTextSt>

      <Donut value={value} max={max} />
    </ScoreSt>
  );
};

export { Score };
